
import { defineComponent } from "vue";
import { IPeriodsModel, IAcademicYearModel } from "@/interfaces/modules";
import PeriodsService from "@/api/Configuration/PeriodsService";
import AcademicYearService from "@/api/Configuration/AcademicYearService";
import store from "@/store";
import moment from "moment";

export default defineComponent({
  name: "App",
  data() {
    return {
      academicYears: [] as IAcademicYearModel[],
      canEdit: true,
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: { Id: 0 } as IPeriodsModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "AcademicYearName", label: "Año académico", sortable: true },
          { key: "Description", label: "Descripción", sortable: true },
          { key: "PeriodNumber", label: "Numero período", sortable: true },
          { key: "CurrentPeriod", label: "Período actual", sortable: true },
          { key: "DateFromFormat", label: "Fecha inicio", sortable: true },
          { key: "DateToFormat", label: "Fecha fin", sortable: true },
          { key: "IsOpen", label: "Registro académico abierto", sortable: true },
          { key: "OpenFrom", label: "Abierto desde", sortable: true },
          { key: "OpenTo", label: "Abierto hasta", sortable: true },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Ultima modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IPeriodsModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  watch: {
    'form.record.AcademicYearId'(val: any) {
      this.form.valid = !val || !this.form.record.AcademicYearId;
    },
    'form.record'(val: any) {
      if (val?.Id == 0)
        this.canEdit = false
      else
        this.canEdit = true
    },
  },
  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter((item: any) =>
          (item.Description || "").toLowerCase().includes(this.table.filters.search.toLowerCase())
        )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      const rows = await PeriodsService.GetPeriods();
      this.academicYears = await AcademicYearService.GetAcademicYears();
      // Añadimos campos derivados para las columnas de fecha (como haces con audit en Identities)
      this.table.records = rows.map((r: any) => ({
        ...r,
        DateFromFormat: r?.DateFrom ? r.DateFrom.substring(0, 10) : "-",
        DateToFormat: r?.DateTo ? r.DateTo.substring(0, 10) : "-",
      }));
      this.table.loading = false;
    },
    async edit(data: IPeriodsModel) {
      const record = await PeriodsService.GetPeriodsById(data);
      this.form.record = record;

      // El backend suele devolver "YYYY-MM-DDTHH:mm:ss". Para el input date sólo necesitamos "YYYY-MM-DD".
      const rawTo = record?.DateTo ? record.DateTo.substring(0, 10) : "";
      const rawFrom = record?.DateFrom ? record.DateFrom.substring(0, 10) : "";

      // Corrige el formato de parseo: la cadena ya viene "YYYY-MM-DD"
      const formatDateTo = rawTo ? moment(rawTo, "YYYY-MM-DD").format("YYYY-MM-DD") : "";
      const formatDateFrom = rawFrom ? moment(rawFrom, "YYYY-MM-DD").format("YYYY-MM-DD") : "";

      this.form.record.DateTo = formatDateTo;
      this.form.record.DateFrom = formatDateFrom;

      // Horas (HH:mm:ss o HH:mm)
      const rawOpenFrom = record?.OpenFrom ? moment(record.OpenFrom).format("HH:mm:ss") : "";
      const rawOpenTo = record?.OpenTo ? moment(record.OpenTo).format("HH:mm:ss") : "";

      // Si tu input es type="time", normalmente usa "HH:mm"
      this.form.record.OpenFrom = rawOpenFrom ? rawOpenFrom.substring(0, 5) : ""; // "HH:mm"
      this.form.record.OpenTo = rawOpenTo ? rawOpenTo.substring(0, 5) : "";   // "HH:mm"

      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Enable: true, Id: 0 } as IPeriodsModel;
      this.form.dialog = true;
    },
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.dialog = false;
      await PeriodsService.PostPeriods(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
